"use strict";
module.exports = {
    'name': 'French',
    'code': 'fr',
    'greeting': 'bonjour',
    'drag & drop': 'drag & drop',
    'or click here to browse': 'ou cliquez ici pour naviguer',
    'follow': 'Seguire',
    'following': 'Seguente',
    'explore tracks': 'Explorer les pistes',
    'create your own': 'Crée le tien',
    'activities': {
        'Cycle': 'Vélo',
        'Mountain Bike': 'Vélo de montagne',
        'Motorcycle': 'Moto',
        'Dirt Bike': 'Moto Cross',
        'Car': 'Voiture',
        'Drive': 'Conduire',
        'Train': 'Train',
        'Equestrian': 'Équestre',
        'Camel': 'Chameau',
        'Horse Riding': 'Équitation',
        'Run': 'Courir',
        'Trail Run': 'Trail Run',
        'XC Ski': 'Ski XC',
        'Snowboard': 'Snowboard',
        'Ski': 'Ski',
        'Snowmobile': 'Snowmobile',
        'Snowshoe': 'Snowshoe',
        'Climb': 'Climb',
        'Mountaineer': 'Mountaineer',
        'Hike': 'Hike',
        'Walk': 'Walk',
        'Trek': 'Trek',
        'Paddle': 'Paddle',
        'Kayak': 'Kayak',
        'Canoe': 'Canoe',
        'Row': 'Row',
        'Motor Boat': 'Motor Boat',
        'Sailing': 'Sailing',
        'Waterski': 'Waterski',
        'Wakeboard': 'Wakeboard',
        'Kitesurf': 'Kitesurf',
        'Surf': 'Surf',
        'Windsurf': 'Windsurf',
        'Swim': 'Swim',
        'Airplane': 'Airplane',
        'Balloon': 'Balloon',
        'Birds': 'Birds',
        'Aviary': 'Aviary',
        'Hang Glide': 'Hang Glide',
        'Paraglide': 'Paraglide',
        'Sailplane': 'Sailplane',
        'Glide': 'Glide',
        'Drone': 'Drone',
        'UAV': 'UAV',
        'Aerial': 'Aerial',
        'Ground': 'Ground',
        'Mixed': 'Mixed',
        'Hike + Glide': 'Hike + Glide',
        'Other': 'Other',
    },
};
